import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button } from "../../components/ui";
import { toast } from "react-toastify";
import MultiSelectDropdown from "../loansV2/multi-select-dropdown";
import useMarketFilters from "./useMarketsFilters";
import useMarkets from "./useMarkets";
import {
  resetMarketsFilters,
  setFilteredMarkets,
  setMarketFiltersPanelOpenStatus,
  setMarketsFilters,
} from "../../reducers/marketSlice";

const MarketsFilters = () => {
  const {
    marketOptions,
    rmOptions,
    filterMode,
    setFilterMode,
    markets,
    setMarkets,
    rms,
    setRms,
    marketFilters,
    handleStatusClick,
    marketStatus,
    setMarketStatus,
    marketStatusArray,
    isFilterApplied,
    activeMarketTab
  } = useMarketFilters();

  const { allMarketsData } = useMarkets();

  const dispatch = useDispatch();

  const handleApplyFilters = () => {
    dispatch(
      setMarketsFilters({
        markets,
        rms,
        status: marketStatus,
        filterMode,
      })
    );
    dispatch(setMarketFiltersPanelOpenStatus(false));
  };

  const handleResetFilters = () => {
    dispatch(resetMarketsFilters());
    setFilterMode("");
    setMarketStatus([]);
    setMarkets([]);
    setRms([]);

    dispatch(setFilteredMarkets(allMarketsData || []));
    toast.success("Filters reset successfully");
  };

  const handleSelectAll = () => {
    if (filterMode === "All") {
      setFilterMode("");
      setMarkets([]);

      setMarketStatus([]);

      setRms([]);
    } else {
      setFilterMode("All");
      setMarkets(marketOptions || []);

      setMarketStatus([...marketStatusArray]);

      setRms(rmOptions || []);
    }
  };

  useEffect(() => {
    const allSelected =
      markets.length === (marketOptions?.length || 0) &&
      marketStatus.length === marketStatusArray.length &&
      rms.length === (rmOptions?.length || 0);

    if (allSelected && filterMode !== "All") {
      setFilterMode("All");
    } else if (!allSelected && filterMode === "All") {
      setFilterMode("");
    }
  }, [markets, marketStatus, rms]);

  const deselectAllIfNeeded = () => {
    if (filterMode === "All") {
      setFilterMode("");
    }
  };

  return (
    <div>
      {" "}
      <div
        className="p-4 bg-gray-bg "
        style={{
          height: "calc(100vh - 9rem)",
        }}
        id="scroll_style"
      >
        <div className="flex gap-10 text-sm font-semibold justify-between w-[80%]">
          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              checked={filterMode === "All"}
              onChange={() => {
                handleSelectAll();
              }}
            />
            Select All
          </label>
        </div>

        {/* Market */}
        <div className="space_18">
          <div className="flex justify-between">
            <label className="block font-bold mb-2 text-sm">
              By Market Name
            </label>
            <span
              className="fs-14 color-red cursor-pointer"
              onClick={() => {
                setMarkets([]);
                deselectAllIfNeeded();
              }}
            >
              Reset
            </span>
          </div>
          <MultiSelectDropdown
            options={marketOptions}
            selected={markets}
            onChange={setMarkets}
            placeholder="Search by Market Name / ID and Select"
          />
        </div>

        {/* RM */}
        <div className="space_18">
          <div className="flex justify-between">
            <label className="block font-bold mb-2 text-sm">
              By Mandi Head
            </label>
            <span
              className="fs-14 color-red cursor-pointer"
              onClick={() => {
                setRms([]);
                deselectAllIfNeeded();
              }}
            >
              Reset
            </span>
          </div>
          <MultiSelectDropdown
            options={rmOptions}
            selected={rms}
            onChange={setRms}
            placeholder="Search by RM Name / ID and Select"
          />
        </div>

        {/* Status */}

        {activeMarketTab === 'ALL' && (
          <div className="space_18">
            <div className="flex justify-between">
              <label className="block font-bold mb-2 text-sm">By Status</label>
              <span
                className="fs-14 color-red cursor-pointer"
                onClick={() => {
                  setMarketStatus([]);
                  deselectAllIfNeeded();
                }}
              >
                Reset
              </span>
            </div>

            <div className="flex gap-2 flex-wrap">
              {marketStatusArray.map((t) => (
                <button
                  key={t}
                  onClick={() => handleStatusClick(t)}
                  className={`px-4 py-2 border br-10 text-sm font-semibold 
        ${marketStatus.includes("All") || marketStatus.includes(t)
                      ? "bg-primary text-white"
                      : "hover:bg-primary bg-white"
                    }`}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
        )}

      </div>
      <div className="flex justify-between mt-4 px-2">
        <Button
          variant="transparent"
          onClick={() => {
            dispatch(setMarketFiltersPanelOpenStatus(false));
          }}
        >
          Cancel
        </Button>

        <div className="flex gap-2">
          {isFilterApplied() && (
            <Button
              className=""
              onClick={() => {
                handleResetFilters();
              }}
              variant="lightRed"
            >
              Reset
            </Button>
          )}
          <Button
            className=""
            onClick={() => {
              handleApplyFilters();
            }}
            variant="contained"
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};
export default MarketsFilters;
